<template>
  <div class="employers-lt-page">
    <div v-if="pending"
         style="min-height: 20rem; position: relative">
      <BasePreloader/>
    </div>

    <div v-else-if="error"
         class="container">
      <ErrorView :code="error.code"
                 :title="error.message"
                 class="container-inner"/>
    </div>
    <template v-else-if="pageData">
      <EmployersLTPageHeader :section="pageData.header"/>
      <EmployersLTPageFirstSection :section="pageData.promo_block"/>
      <EmployersLTPageHowItWork :section="pageData.how_it_works"/>
      <EmployersLTPageOrder :section="pageData.form"/>
      <EmployersLTPageInfoSection v-if="pageData.text_block"
                                  :section="pageData.text_block"/>
      <EmployersLTPageAgents v-if="$get(pageData.reviews, 'items.data.length')"
                             :section="pageData.reviews"/>
      <AddressSection :title="pageData.addresses.title"
                      :addresses="pageData.addresses.items"
                      class="employers-lt-page__addresses  _4-cols"/>
      <EmployersLTPageVideo :section="pageData.video"/>
      <EmployersLTPageFooter :section="pageData.footer"/>
    </template>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import globalMetaMixin from '@/mixins/globalMetaMixin'
  import defer from '@/mixins/defer'
  import {removeAllAlternate, setHref} from '@/router/common/setAlternate'
  import ErrorView from '@/components/ErrorView'
  import EmployersLTPageHeader from '@/components/employersLTPage/EmployersLTPageHeader'
  import EmployersLTPageFirstSection from '@/components/employersLTPage/EmployersLTPageFirstSection'
  import EmployersLTPageHowItWork from '@/components/employersLTPage/EmployersLTPageHowItWork'
  import EmployersLTPageInfoSection from '@/components/employersLTPage/EmployersLTPageInfoSection'
  import EmployersLTPageAgents from '@/components/employersLTPage/EmployersLTPageAgents'
  import AddressSection from '@/components/AddressSection'
  import EmployersLTPageVideo from '@/components/employersLTPage/EmployersLTPageVideo'
  import EmployersLTPageOrder from '@/components/employersLTPage/EmployersLTPageOrder'
  import EmployersLTPageFooter from '@/components/employersLTPage/EmployersLTPageFooter'

  export default {
    name: 'EmployersLTPage',
    mixins: [globalMetaMixin, defer()],
    props: {
      video: Object
    },
    components: {
      ErrorView,
      EmployersLTPageHeader,
      EmployersLTPageFirstSection,
      EmployersLTPageHowItWork,
      EmployersLTPageInfoSection,
      EmployersLTPageAgents,
      AddressSection,
      EmployersLTPageVideo,
      EmployersLTPageOrder,
      EmployersLTPageFooter,
    },
    data() {
      return {
        error: null,
        pending: false,
        pageData: null,
      }
    },
    computed: {
      currentLang() {
        const r = this.$route.params.lang
        return r || 'ua'
      },
      languagesComputed() {
        const languages = this.pageData.footer.languages.languages
        const r = []

        for (const key in languages) {
          const el = languages[key]

          el.key = key
          r.push(el)
        }

        return r
      }
    },
    methods: {
      load() {
        this.pending = true

        return http.get('/api/helper/landing/employer-lithua').then(({data}) => {
          this.pageData = data.data

          if (!this.pageData.text_block.button) {
            this.pageData.text_block.button = data.data.how_it_works.button
          }

          const meta = data.data.header

          if (meta.meta_title) {
            this.setMetaTitleMixin(meta.meta_title)
          }

          if (meta.meta_description) {
            this.setMetaDescriptionMixin(meta.meta_description)
          }

          if (meta.meta_keywords) {
            this.setMetaKeywords(meta.meta_keywords)
          }

          this.setOpenGraph({
            title: meta.meta_title && this.setMetaTitleMixin(meta.meta_title),
            description: meta.meta_description && this.setMetaDescriptionMixin(meta.meta_description),
          })

          this.runDisplayPriority()

          this.setAlternate()
        }).finally(() => {
          this.pending = false
        })
      },
      setAlternate() {
        removeAllAlternate()
        const currentLang = this.currentLang
        let path = this.$route.path

        if (path.startsWith(`/${currentLang}/`)) {
          path = path.slice(3)
        }

        for (const language of this.languagesComputed) {
          if (language.key === this.currentLang) continue

          const href = `${origin}${currentLang === 'ua' ? '' : '/' + currentLang}${path}`
          setHref(href, language.regional)
        }
      }
    },
    created() {
      this.load()
    },
  }
</script>

<style lang="less">

</style>
